import { render, staticRenderFns } from "./customAlert.vue?vue&type=template&id=60a06734&scoped=true&"
import script from "./customAlert.vue?vue&type=script&lang=js&"
export * from "./customAlert.vue?vue&type=script&lang=js&"
import style0 from "./customAlert.vue?vue&type=style&index=0&id=60a06734&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a06734",
  null
  
)

export default component.exports